import { useQuery, useQueryClient } from '@tanstack/react-query';

import * as ApiMeta from '@Api/Meta';
import { useRequest } from '@Contexts/Request';
import useNavigation from '@Navigation/useNavigation';

const usePageTranslation = () => {
  const { pathname } = useNavigation();
  const request = useRequest();
  const { country, language } = request;
  const queryClient = useQueryClient();
  const params = { country, lang: language.id, pathname };
  const keys = ['translation', 'page', params];

  return useQuery({
    queryKey: keys,
    queryFn: () => {
      const cache = queryClient.getQueryData(keys);

      if (cache) return Promise.resolve(cache);

      return ApiMeta.getPageTranslation(params, request);
    },
    enabled: true,
    placeholderData: (previousData) => previousData,
  });
};

export default usePageTranslation;
